<template>
  <div>
    <iframe v-for="(item,index) in quickApplyList" :key="index" :src="item.value" v-show="pageCode==item.id" v-if="item.isShow" width="100%" :height="screenHeight" scrolling="auto" frameborder="0"></iframe>
  </div>
</template>

<script>
    export default {
        name: "webPage",
        props:{
          pageCode:String,
          quickApplyList:Array,
        },
        data(){
          return{
            screenHeight:'',
          }
        },
        methods:{

        },
        watch:{
          pageCode:function () {
            this.screenHeight=document.documentElement.clientHeight-98;
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fastApplication/webPage.vue